(function() {
  const PANEL_SELECTOR = '[data-lbec-quote-panel]';
  const CARD_SELECTOR = 'a[data-lbec-card][href="#engraving-quote"], a[data-lbec-card][href="#design-quote"]';
  const RESET_SELECTOR = '[data-lbec-quote-reset]';

  const panelMap = {
    '#engraving-quote': 'engraving',
    '#design-quote': 'design'
  };

  const getPanels = () => Array.from(document.querySelectorAll(PANEL_SELECTOR));
  const getResetButtons = () => Array.from(document.querySelectorAll(RESET_SELECTOR));
  const hasChooserCards = () => document.querySelectorAll(CARD_SELECTOR).length > 0;

  const getChooser = () => {
    return (
      document.querySelector('[id^="shopify-section-lbec_shop_ready_builder_quote_paths"]') ||
      document.querySelector('.lbec-shop--builder')
    );
  };

  const setActivePanel = (panelName, options) => {
    const opts = options || {};
    const panels = getPanels();
    const chooser = getChooser();
    let activePanel = null;

    panels.forEach((panel) => {
      const isActive = panel.dataset.lbecQuotePanel === panelName;
      panel.hidden = !isActive;
      if (isActive) {
        activePanel = panel;
      }
    });

    if (!activePanel) {
      return;
    }

    if (chooser) {
      chooser.hidden = true;
    }

    if (opts.updateHash) {
      const hash = panelName === 'design' ? '#design-quote' : '#engraving-quote';
      if (window.location.hash !== hash) {
        window.history.replaceState(null, '', hash);
      }
    }

    if (opts.scroll !== false) {
      window.requestAnimationFrame(() => {
        activePanel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  const resetPanels = () => {
    const panels = getPanels();
    const chooserMode = hasChooserCards();
    const chooser = getChooser();

    panels.forEach((panel) => {
      panel.hidden = chooserMode;
    });

    getResetButtons().forEach((button) => {
      button.hidden = !chooserMode;
    });

    if (!chooserMode) {
      if (chooser) {
        chooser.hidden = false;
      }
      return;
    }

    if (chooser) {
      chooser.hidden = false;
    }

    if (window.location.hash === '#engraving-quote' || window.location.hash === '#design-quote') {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    if (chooser) {
      window.requestAnimationFrame(() => {
        chooser.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  };

  const handleCardClick = (event) => {
    if (!hasChooserCards()) {
      return;
    }

    const card = event.target.closest(CARD_SELECTOR);
    if (!card) {
      return;
    }

    const panelName = panelMap[card.getAttribute('href')];
    if (!panelName) {
      return;
    }

    event.preventDefault();
    setActivePanel(panelName, { updateHash: true, scroll: true });
  };

  const handleResetClick = (event) => {
    const button = event.target.closest(RESET_SELECTOR);
    if (!button) {
      return;
    }

    event.preventDefault();
    resetPanels();
  };

  const initFromHash = () => {
    if (!hasChooserCards()) {
      resetPanels();
      return;
    }

    const panelName = panelMap[window.location.hash];
    if (panelName) {
      setActivePanel(panelName, { updateHash: false, scroll: false });
      return;
    }

    resetPanels();
  };

  const init = () => {
    document.removeEventListener('click', handleCardClick);
    document.removeEventListener('click', handleResetClick);
    document.addEventListener('click', handleCardClick);
    document.addEventListener('click', handleResetClick);
    initFromHash();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.addEventListener('hashchange', initFromHash);
  document.addEventListener('shopify:section:load', init);
})();
